import Field from "../core/field.es6.js";
import SubmitFormElementParagraph from "../paragraphs/form-element-submit-paragraph.es6.js";

export default class SubmitFormElementParagraphField extends Field {
  get paragraph() {
    return new SubmitFormElementParagraph({ parentElement: this });
  }
}
